import React from "react";
import { AdminManageContextProvider } from "./ViewAdminView";
import AdminManageView from "./views/AdminView";

const ViewAdminManagePage = () => {
  return (
    <div>
      <AdminManageContextProvider>
        <AdminManageView />
      </AdminManageContextProvider>
    </div>
  );
};

export default ViewAdminManagePage;
